import MapboxDraw, { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import { SnapPointMode } from "mapbox-gl-draw-snap-mode";

import { removeGuides } from "./helper";

const { constants: Constants } = MapboxDraw;

/*
 * A modified draw_point mode that stays in draw_point when a point is created,
 * rather than moving back to simple_select and requiring the user to re-enter
 * draw point mode to create the next point.
 */
const drawPoint: DrawCustomMode = {
  ...SnapPointMode,

  onSetup: function (opts) {
    const state = SnapPointMode.onSetup?.call(this, opts);
    removeGuides.call(this);

    return state;
  },

  onClick: function (this, state) {
    state.point.updateCoordinate("", state.snappedLng, state.snappedLat);

    this.map.fire(Constants.events.CREATE, {
      features: [state.point.toGeoJSON()],
    });

    // We trigger the changeMode to DRAW_POINT again to stay in draw mode after creating a point,
    // instead of switching back to simple_select.
    this.changeMode(Constants.modes.DRAW_POINT);
  },
};

export default drawPoint;
